// top.js
import Swiper from "swiper";
import { Autoplay, Pagination, Navigation, EffectFade } from "swiper/modules";
import "swiper/css";

// GSAP / ScrollTrigger の初期化
import { ScrollTrigger } from "../common/gsap";

/* =========================
   共通ユーティリティ
========================= */
const BREAKPOINT_SP = "(max-width: 768px)";

const addSwiperClasses = (rootEl, sliderEl, listEl) => {
  rootEl?.classList.add("is-swiper");
  sliderEl?.classList.add("swiper");
  listEl?.classList.add("swiper-wrapper");
  listEl &&
    [...listEl.children].forEach((el) => el.classList.add("swiper-slide"));
};

const removeSwiperClasses = (rootEl, sliderEl, listEl) => {
  rootEl?.classList.remove("is-swiper");
  sliderEl?.classList.remove("swiper");
  listEl?.classList.remove("swiper-wrapper");
  listEl &&
    [...listEl.children].forEach((el) => el.classList.remove("swiper-slide"));
};

const onMediaChange = (mq, handler) => {
  if ("addEventListener" in mq) mq.addEventListener("change", handler);
  else if ("addListener" in mq) mq.addListener(handler);
};

const refreshST = () => {
  if (typeof ScrollTrigger !== "undefined" && ScrollTrigger?.refresh) {
    ScrollTrigger.refresh();
  } else if (window.ScrollTrigger?.refresh) {
    window.ScrollTrigger.refresh();
  }
};

/* =========================
   Voices (PC: grid / SP: Swiper)
========================= */
let voicesSwiper = null;
const mqVoices = window.matchMedia(BREAKPOINT_SP);

const VOICES_ROOT = document.querySelector(".p-top-voices");
const VOICES_SLIDER = document.querySelector(".p-top-voices__slider");
const VOICES_LIST = document.getElementById("js-voices-list");

function enableVoicesSwiper() {
  if (voicesSwiper || !VOICES_ROOT || !VOICES_SLIDER || !VOICES_LIST) return;

  addSwiperClasses(VOICES_ROOT, VOICES_SLIDER, VOICES_LIST);

  const CONTROLS = VOICES_ROOT.querySelector(".p-top-voices__controls");
  const VOICES_PAGI = CONTROLS?.querySelector(".p-top-voices__pagination");
  const VOICES_NEXT = CONTROLS?.querySelector(".p-top-voices__next");
  const VOICES_PREV = CONTROLS?.querySelector(".p-top-voices__prev");

  const slideCount = VOICES_LIST.children.length;
  const canLoop = slideCount >= 2;
  const allowSwipe = slideCount > 1;

  voicesSwiper = new Swiper(VOICES_SLIDER, {
    modules: [Autoplay, Pagination, EffectFade, Navigation],
    effect: "fade",
    fadeEffect: { crossFade: true },
    preloadImages: true,
    watchSlidesProgress: true,

    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 0,
    autoHeight: true,
    loop: canLoop,
    rewind: !canLoop,
    allowTouchMove: allowSwipe,
    watchOverflow: true,
    speed: 1000,
    autoplay: false,
    pagination: VOICES_PAGI ? { el: VOICES_PAGI, clickable: true } : undefined,
    navigation:
      VOICES_NEXT && VOICES_PREV
        ? { nextEl: VOICES_NEXT, prevEl: VOICES_PREV }
        : undefined,
  });

  voicesSwiper.on("afterInit", refreshST);
  voicesSwiper.on("imagesReady", refreshST);
  voicesSwiper.on("slideChangeTransitionEnd", refreshST);
}

function disableVoicesSwiper() {
  if (!VOICES_ROOT || !VOICES_SLIDER || !VOICES_LIST) return;

  if (voicesSwiper) {
    voicesSwiper.destroy(true, true);
    voicesSwiper = null;
  }

  removeSwiperClasses(VOICES_ROOT, VOICES_SLIDER, VOICES_LIST);
  refreshST();
}

function handleVoicesBreakpoint(e) {
  if (e.matches) {
    // SP
    enableVoicesSwiper();
  } else {
    // PC
    disableVoicesSwiper();
  }
  requestAnimationFrame(refreshST);
}

/* =========================
   起動（Voicesのみ外側で起動）
========================= */
window.addEventListener("load", () => {
  handleVoicesBreakpoint(mqVoices);
  onMediaChange(mqVoices, handleVoicesBreakpoint);
});

window.addEventListener("pageshow", (ev) => {
  // bfcache から復帰したときのみ
  if (!ev.persisted) return;

  if (mqVoices.matches) {
    // SP
    disableVoicesSwiper();
    enableVoicesSwiper();
  } else {
    // PC
    disableVoicesSwiper();
  }
  requestAnimationFrame(refreshST);
});
